"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var YandexMap = /** @class */ (function (_super) {
    tslib_1.__extends(YandexMap, _super);
    function YandexMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexMap.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, center = _a.center, zoom = _a.zoom;
        var options = {
            zoom: zoom,
            center: [center.latitude, center.longitude],
            controls: ['zoomControl', 'fullscreenControl'],
        };
        this.mapInstance = new window.ymaps.Map(this.container, options);
        this.mapInstance.copyrights.add('<a href="//alakatto.ru/" target="_blank" title="Алакатто">Алакатто</a>');
        this.mapInstance.behaviors.disable('scrollZoom');
        this.props.markers.forEach(function (marker) {
            _this.mapInstance.geoObjects.add(new window.ymaps.Placemark([marker.latitude, marker.longitude], {
                hintContent: 'Алакатто',
                balloonContentHeader: 'Алакатто',
                balloonContentBody: 'ул. Полевая Сабировская, 46Т',
                balloonContentFooter: '<a href="tel:88123272828">(812) 327-28-28</a>',
            }, {
                // Опции.
                // Необходимо указать данный тип макета.
                iconLayout: 'default#image',
            }));
        });
    };
    YandexMap.prototype.shouldComponentUpdate = function () {
        return false;
    };
    YandexMap.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { ref: function (node) { return (_this.container = node); }, style: { width: '100%', height: "100%" } }));
    };
    return YandexMap;
}(react_1.default.Component));
exports.YandexMap = YandexMap;
